import * as React from 'react';
import { apiUrl } from 'utils/apiUrl';
import { useAppConfigContext } from 'contexts/AppConfigContext';
import { AccumulatedExecutions, useAccumulatedExecutions } from 'hooks/useAccumulatedExecutions';

/**
 * Pages fetched automatically before handing paging over to the user. Regional executions are a
 * mix of mass jobs and mass queries, so a single page can contain none of one type; loading a few
 * up front keeps a type-filtered view from looking empty when matches exist further in.
 */
export const MAX_AUTO_LOAD_PAGES = 5;

export interface RegionalExecutions extends AccumulatedExecutions {
  readonly region: string;
  readonly regions: string[];
  readonly setRegion: (region: string) => void;
}

export const useRegionalExecutions = (): RegionalExecutions => {
  const env = useAppConfigContext();
  const regions = React.useMemo(
    () => env.houstonSupportedRegions ?? ['us-east-1'],
    [env.houstonSupportedRegions],
  );
  const [region, setRegion] = React.useState<string>(regions[0]);

  // Switching region changes the URL, which is what tells the list to start again.
  const url = apiUrl('lct', `regions/${region}/tenantTypes/Regional/jobManager/executions`);
  const executions = useAccumulatedExecutions({ url, autoLoadPages: MAX_AUTO_LOAD_PAGES });

  return { region, regions, setRegion, ...executions };
};

export default useRegionalExecutions;
